import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a1509f31e93da001437960d_1781742821340_055df351/baitulgufron/src/app/display-screen/components/DisplayScreenClient.tsx");
